module.exports = __webpack_public_path__ + "img/re4.9503dcca.png";